import { render, staticRenderFns } from "./ConsolidationCard.vue?vue&type=template&id=e6878b74&scoped=true"
import script from "./ConsolidationCard.vue?vue&type=script&lang=js"
export * from "./ConsolidationCard.vue?vue&type=script&lang=js"
import style0 from "./ConsolidationCard.vue?vue&type=style&index=0&id=e6878b74&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e6878b74",
  null
  
)

export default component.exports